import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import { Delete, Get, Patch, handleError } from "../../../utils/fetch.util";
import { toast } from "react-toastify";
import i18next, { t } from "i18next";
import NoData from "../../../components/noData/noData.component";
import { MdDeleteOutline, MdOutlineRestore } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import ReactPaginate from "react-paginate";
import LoadingData from "../../../components/loadingData/loadingData.component";
import { GuidebookType } from "../../../types/guidebook-type";
import { BackNavigator } from "../../../components/BackNavigator/BackNavigator.component";
import Select from "react-select";

const DeletedGuidebookss = () => {
  const { getValidToken } = useContext(UserContext);

  const [deletedGuidebooks, setDeletedGuidebooks] = useState<any[]>([]);
  const [deletedVideos, setDeletedVideos] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [deletedDataPage, setDeletedDataPage] = useState<number>(1);
  const [deletedDataCount, setDeletedDataCount] = useState<number>(0);
  const [filterQuery, setFilterQuery] = useState<any>("guidebooks");
  const pageItemsCount = 10;

  const guideBookOrVideoOptions = [
    // { value: "all", label: t("all") },
    { value: "guidebooks", label: t("guiidebooks") },
    { value: "videos", label: t("videos") },
  ];

  const getAllItemsDeleted = async () => {
    setIsLoading(true);
    const res = await Get(
      `site-guidebook/get-all-deleted-guidebooks?page=${deletedDataPage}&pageItemsCount=${pageItemsCount}`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setDeletedGuidebooks(res.data);
    setDeletedDataCount(res.count);
  };

  const getAllVideosDeleted = async () => {
    setIsLoading(true);
    const res = await Get(
      `site-video/get-all-deleted-videos?page=${deletedDataPage}&pageItemsCount=${pageItemsCount}`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setDeletedVideos(res.data);
    setDeletedDataCount(res.count);
  };

  const handleRestoreItem = async (id: number) => {
    setIsLoading(true);
    const guidebookObj = {
      site_guidebook_id: id,
    };
    const videoObj = {
      video_id: id,
    };

    const res = await Patch(
      filterQuery === "guidebooks"
        ? `site-guidebook/restore-guidebook`
        : `site-video/restore-video`,
      filterQuery === "guidebooks" ? guidebookObj : videoObj,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }
    toast.success("Successfully Restore");
    setIsLoading(false);
    filterQuery === "guidebooks" ? getAllItemsDeleted() : getAllVideosDeleted();
  };

  const handleDeleteItemPermanently = async (id: number) => {
    setIsLoading(true);
    const res = await Delete(
      filterQuery === "guidebooks"
        ? `site-guidebook/delete-guidebook-permanently?site_guidebook_id=${id}`
        : `site-video/delete-video-permanently?video_id=${id}`,
      getValidToken()
    );

    if (res.error || !res.data) {
      handleError(res);
      setIsLoading(false);
      return;
    }
    toast.success("Successfully Deleted");
    setIsLoading(false);
    filterQuery === "guidebooks" ? getAllItemsDeleted() : getAllVideosDeleted();
  };

  useEffect(() => {
    getAllItemsDeleted();
    getAllVideosDeleted();
  }, [deletedDataPage]);

  if (isLoading) return <LoadingData />;

  return (
    <>
      <div className="w-full">
        <BackNavigator className="mt-4" />
        <div className="flex items-center justify-between">
          <h1 className="text-3xl md:text-5xl mt-8 mb-12">
            {t(
              filterQuery === "guidebooks"
                ? "deleted_guidebooks"
                : "deleted_videos"
            )}{" "}
            <span className="text-2xl">
              (
              {filterQuery === "guidebooks"
                ? deletedGuidebooks?.length
                : deletedVideos?.length}
              )
            </span>
          </h1>
          <div className="flex items-center gap-x-4">
            <Select
              className="rounded-md border-secondary p-1 w-44"
              options={guideBookOrVideoOptions}
              value={guideBookOrVideoOptions.find(
                (option) => option.value === filterQuery
              )}
              onChange={(e: any) => {
                setFilterQuery(e?.value);
              }}
            />
            <div className="relative">
              <input
                className="w-full h-10 bg-transparent border border-gray-300 rounded-3xl text-text ps-11 focus:outline-none outline-none focus:ps-9 duration-300"
                type="search"
                placeholder="Search..."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                value={searchValue}
              />
              <CiSearch className="absolute start-2 top-1/2 transform -translate-y-1/2 text-text text-xl" />
            </div>
          </div>
        </div>
        {filterQuery === "guidebooks" && deletedGuidebooks?.length < 1 ? (
          <div className="flex justify-center items-center h-[300px] mt-20">
            <NoData message={t("no_data_deleted")} />
          </div>
        ) : filterQuery === "videos" && deletedVideos?.length < 1 ? (
          <div className="flex justify-center items-center h-[300px] mt-20">
            <NoData message={t("no_data_deleted")} />
          </div>
        ) : (
          <>
            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse mt-5">
                <thead>
                  <tr className="border-collapse border-2">
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("id")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("name")}
                    </th>
                    {/* <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("sites")}
                    </th> */}
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  {(filterQuery === "guidebooks"
                    ? deletedGuidebooks?.filter((guidebook: GuidebookType) =>
                        guidebook.site_guidebook_name
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                    : deletedVideos?.filter((video) =>
                        video.site_video_name
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                  )?.map((item) => {
                    return (
                      <tr
                        className={`border-collapse border-2`}
                        key={
                          item.site_guidebook_id?.toString() ??
                          item.site_video_id?.toString()
                        }
                      >
                        <td className="border-collapse border-2 p-3 capitalize min-w-[100px]">
                          {item.site_guidebook_id?.toString() ??
                            item.site_video_id?.toString()}
                        </td>
                        <td className="border-collapse border-2 p-3 capitalize min-w-[100px]">
                          {item.site_guidebook_name?.toString() ??
                            item.site_video_name?.toString()}
                        </td>
                        {/* 
                                <td className="border-collapse border-2 p-3 capitalize min-w-[100px]">
                                  {item.sites?.map((site: SiteType) => site.site_name)}
                                </td>
                              */}
                        <td className="border-collapse border-2 p-3 capitalize min-w-[100px]">
                          <div className="flex items-center gap-3">
                            <button
                              onClick={() => {
                                handleRestoreItem(
                                  item.site_guidebook_id.toString() ??
                                    item.site_video_id.toString()
                                );
                              }}
                            >
                              <MdOutlineRestore size={25} />
                            </button>
                            <button
                              onClick={() => {
                                handleDeleteItemPermanently(
                                  item.site_guidebook_id.toString() ??
                                    item.site_video_id
                                );
                              }}
                            >
                              <MdDeleteOutline
                                className="text-red-500"
                                size={25}
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        )}
        {pageItemsCount &&
        (filterQuery === "guidebooks"
          ? deletedGuidebooks?.length
          : deletedVideos?.length) > 0 ? (
          <ReactPaginate
            className="pagination_table"
            containerClassName={"pagination"}
            activeClassName={"active"}
            pageClassName={"page-item"}
            forcePage={deletedDataPage - 1}
            onPageChange={(event) => setDeletedDataPage(event.selected + 1)}
            breakLabel="..."
            pageCount={Math.ceil(deletedDataCount / pageItemsCount)}
            previousLabel={
              deletedDataPage == 1 ? null : (
                <div
                  style={{
                    backgroundColor: "#B8C1CC",
                    width: "36px",
                    height: "36px",
                  }}
                  className="flex items-center justify-center rounded-full text-white"
                >
                  <GrFormPrevious size={28} />
                </div>
              )
            }
            nextLabel={
              deletedDataPage ==
              Math.ceil(deletedDataCount / pageItemsCount) ? null : (
                <div
                  style={{
                    backgroundColor: "#B8C1CC",
                    width: "36px",
                    height: "36px",
                  }}
                  className="flex items-center justify-center rounded-full text-white"
                >
                  <GrFormNext size={28} />
                </div>
              )
            }
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default DeletedGuidebookss;
